import axios from "axios";

import { API_URL } from "../utils/Constant";

/**
 * POST /coa/preview/ — generate COA PDF on backend.
 * @param {Object} payload preview request body (user fields added by interceptor)
 * @param {AbortSignal} [signal]
 */
export const previewCoa = async (payload, signal = null) => {
  try {
    const response = await axios.post(`${API_URL}/coa/preview/`, payload, signal ? { signal } : {});
    const data = response.data;
    return {
      success: true,
      message: data.message,
      result: data.result,
    };
  } catch (e) {
    if (axios.isCancel(e)) {
      return { success: false, canceled: true };
    }
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
    };
  }
};

/**
 * POST /coa/preview-from-sample/ — generate a filled COA PDF for a sample + template.
 * Customer fields (user_payload, company_name, company_domain) are added by the interceptor.
 * @param {Object} payload preview request body
 * @param {AbortSignal} [signal]
 */
export const previewCoaFromSample = async (payload, signal = null) => {
  try {
    const response = await axios.post(`${API_URL}/coa/preview-from-sample/`, payload, signal ? { signal } : {});
    const data = response.data;
    return {
      success: true,
      message: data.message,
      result: data.result,
    };
  } catch (e) {
    if (axios.isCancel(e)) {
      return { success: false, canceled: true };
    }
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
    };
  }
};
